import { getCmsLocaleString } from 'js/lib/language';
import { useLocation, useParams, useRoutes } from 'js/lib/useRouter';

import type { ProductType } from 'bundles/xddp/types';

export const usePropsFromRouter = () => {
  const location = useLocation();
  const { slug, specializationSlug } = useParams();
  const routes = useRoutes();

  const previewParam = location.query.preview;
  const versionParam = location.query.v;
  const isPreview = !!previewParam && Number(previewParam) === 1;

  // coursera.org/certificates/:slug/landing --> certificates
  const routeProductType = routes[routes.length - 1].path?.split('/').filter((part) => part.length > 0)?.[0];
  const productType: ProductType = routeProductType?.toLowerCase()?.includes('mastertrack')
    ? 'mastertrack'
    : 'universityCertificate';

  const currentRouteName = routes[routes.length - 1].name;

  return {
    slug,
    isPreview,
    versionParam,
    productType,
    locale: getCmsLocaleString(),
    specializationSlug,
    currentRouteName,
  };
};
